(() => {
  'use strict';

  const taurusProducts = ['70492589654353','70492589719889','70492589752657','71100043592017'];
  const isTaurus = gallery => gallery.dataset.productHandle === 'zodiac-vedhaeng-tyren';
  const orderTaurusMedia = gallery => {
    if (!isTaurus(gallery) || gallery.dataset.gemmariiProductFirst) return;
    for (const selector of ['.product-media-gallery .swiper-wrapper', '.product-thumbnails .swiper-wrapper']) {
      const wrapper = gallery.querySelector(selector);
      if (!wrapper) continue;
      const slides = [...wrapper.children];
      slides.sort((a,b) => Number(!taurusProducts.includes(String(a.dataset.mediaId))) - Number(!taurusProducts.includes(String(b.dataset.mediaId))));
      wrapper.append(...slides);
    }
    gallery.dataset.gemmariiProductFirst = 'true';
    gallery.querySelector('.product-media-gallery')?.swiper?.update();
    gallery.querySelector('.product-thumbnails')?.swiper?.update();
  };
  const touchStarts = new WeakMap();
  const variantMapCache = new WeakMap();

  const variantMap = (gallery) => {
    if (variantMapCache.has(gallery)) return variantMapCache.get(gallery);
    const source = gallery.querySelector('script[data-gemmarii-variant-media-map]');
    let parsed = {};
    try { parsed = JSON.parse(source?.textContent || '{}'); } catch (_) {}
    variantMapCache.set(gallery, parsed);
    return parsed;
  };

  const normalizeText = (value) => String(value || '')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleLowerCase()
    .replace(/(\d)[.,](\d+)/g, (_match, integer, fraction) => `${integer}.${fraction.replace(/0+$/, '') || '0'}`)
    .replace(/[^a-z0-9æøå]+/g, ' ')
    .trim();

  const variantRecords = (gallery) => Object.entries(variantMap(gallery))
    .map(([variantId, value]) => ({
      variantId: String(variantId),
      mediaId: String(value && typeof value === 'object' ? value.mediaId || '' : value || ''),
      options: Array.isArray(value?.options) ? value.options.map(String) : []
    }))
    .filter((variant) => variant.mediaId);

  const mediaOptionIndexes = (variants) => {
    const optionCount = Math.max(0, ...variants.map((variant) => variant.options.length));
    const relevant = [];

    for (let index = 0; index < optionCount; index += 1) {
      const groups = new Map();
      variants.forEach((variant) => {
        const key = JSON.stringify(variant.options.filter((_, optionIndex) => optionIndex !== index));
        if (!groups.has(key)) groups.set(key, []);
        groups.get(key).push(variant);
      });

      const changesMedia = Array.from(groups.values()).some((group) => {
        const optionValues = new Set(group.map((variant) => normalizeText(variant.options[index])));
        const mediaIds = new Set(group.map((variant) => variant.mediaId));
        return optionValues.size > 1 && mediaIds.size > 1;
      });
      if (changesMedia) relevant.push(index);
    }

    return relevant;
  };

  const mediaMatchesOptions = (thumbnail, options) => {
    const alt = normalizeText(thumbnail.dataset.mediaAlt || thumbnail.querySelector('img')?.alt);
    if (!alt || !options.length) return false;
    const words = new Set(alt.split(' ').filter(Boolean));
    return options.every((option) => normalizeText(option).split(' ').filter(Boolean).every((word) => words.has(word)));
  };

  // Pea-chain photos are assigned explicitly; alt text remains descriptive.
  const chainMediaGroups = {"70492594143569":["70492594143569","70492594176337","70492594209105","70492594241873","71923246760273"],"71923920863569":["71923920863569","71923923091793","71923924959569","71923926761809"],"71923927777617":["71923927777617","71923669139793"],"71923246760273":["71923246760273","71923383501137","71923384254801","71923385467217","71923616678225"],"71923248988497":["71923248988497","71923383501137","71923384254801","71923385467217","71923616678225"],"71923250725201":["71923250725201","71923383501137","71923384254801","71923385467217","71923616678225"],"71923251806545":["71923251806545","71923387760977"]};
  const additionalChainMediaGroups = {"71924988281169": ["71924988281169", "71925008597329", "71925009482065", "71925015642449"], "71924993098065": ["71924993098065", "71925008597329", "71925009482065", "71925015642449"], "71924991557969": ["71924991557969", "71925008597329", "71925009482065", "71925015642449"], "71924995916113": ["71924995916113", "71925005484369"], "71924994376017": ["71924994376017", "71925003977041"], "71924997226833": ["71924997226833", "71925007057233"], "71924979106129": ["71924979106129", "71925012136273", "71925002502481", "71925016920401", "71925010628945"], "71924980482385": ["71924980482385", "71925012136273", "71925002502481", "71925016920401", "71925010628945"], "71924983333201": ["71924983333201", "71925012136273", "71925002502481", "71925016920401", "71925010628945"], "71924986052945": ["71924986052945", "71924998635857"], "71924987003217": ["71924987003217", "71925001158993"], "71924968685905": ["71924968685905", "71925014757713", "71925185708369", "71925016920401", "71925010628945"], "71924970750289": ["71924970750289", "71925014757713", "71925185708369", "71925016920401", "71925010628945"], "71924971766097": ["71924971766097", "71925014757713", "71925185708369", "71925016920401", "71925010628945"], "71924972716369": ["71924972716369"], "71924973764945": ["71924973764945"], "71924975272273": ["71924975272273"], "71925017674065": ["71925017674065", "71925018558801", "71925021245777", "71925022130513", "71925023146321"], "71925025276241": ["71925025276241", "71925026292049", "71925027602769", "71925028487505", "71925029273937"], "71925030846801": ["71925030846801", "71925032714577", "71925034058065", "71925034877265", "71925036122449"], "71925037367633": ["71925037367633", "71925038580049", "71925039399249", "71925040415057", "71925041561937"]};
  const mediaIdsForSelection = (gallery, mediaId, thumbnails) => {
    if (['ankerkaede-i-18-karat-guld','elegant-halskaede-i-18-karat-guld'].includes(gallery.dataset.productHandle) && additionalChainMediaGroups[String(mediaId)]) return additionalChainMediaGroups[String(mediaId)];
    if (gallery.dataset.productHandle === 'aertekaede-i-18-karat-guld' && chainMediaGroups[String(mediaId)]) {
      return chainMediaGroups[String(mediaId)];
    }
    const variants = variantRecords(gallery);
    const selectedVariant = variants.find((variant) => variant.mediaId === String(mediaId));
    if (!selectedVariant) return [String(mediaId)];

    const options = mediaOptionIndexes(variants)
      .map((index) => selectedVariant.options[index])
      .filter(Boolean);
    const matching = thumbnails
      .filter((thumbnail) => mediaMatchesOptions(thumbnail, options))
      .map((thumbnail) => String(thumbnail.dataset.mediaId || ''))
      .filter(Boolean);

    return Array.from(new Set([String(mediaId), ...matching]));
  };

  const optionSelection = (selector, clickedOption) => Array.from(
    selector.querySelectorAll('select, .variant-options'),
    (group) => {
      if (clickedOption && group.contains(clickedOption)) {
        return String(clickedOption.dataset.swatch || clickedOption.querySelector('input')?.value || '');
      }
      if (group.matches('select')) {
        const option = group.options[group.selectedIndex];
        return option?.dataset.value && option.value ? String(option.value) : '';
      }
      const selected = group.querySelector(
        '.variant-option-item.selected, .variant-option-item[aria-checked="true"], .variant-option-item input:checked'
      );
      const selectedItem = selected?.closest('.variant-option-item') || selected;
      return String(selectedItem?.dataset.swatch || selectedItem?.querySelector('input')?.value || '');
    }
  );

  const mediaIdsForOptions = (gallery, selector, thumbnails, clickedOption) => {
    const variants = variantRecords(gallery);
    const selected = optionSelection(selector, clickedOption);
    const relevantIndexes = mediaOptionIndexes(variants);
    const mediaSelections = relevantIndexes
      .map((index) => ({ index, value: selected[index] }))
      .filter(({ value }) => value);

    if (!mediaSelections.length) return null;

    const matchingVariantMediaIds = new Set(
      variants
        .filter((variant) => mediaSelections.every(({ index, value }) =>
          normalizeText(variant.options[index]) === normalizeText(value)))
        .map((variant) => variant.mediaId)
    );
    const selectedMediaOptions = mediaSelections.map(({ value }) => value);
    const matchingThumbnailIds = thumbnails
      .filter((thumbnail) =>
        matchingVariantMediaIds.has(String(thumbnail.dataset.mediaId || ''))
        || mediaMatchesOptions(thumbnail, selectedMediaOptions))
      .map((thumbnail) => String(thumbnail.dataset.mediaId || ''))
      .filter(Boolean);

    return Array.from(new Set(matchingThumbnailIds));
  };

  const allowedMediaIds = (gallery) => (gallery.dataset.gemmariiAllowedMediaIds || '').split(',').filter(Boolean);
  const mainSwiper = (gallery) => gallery.querySelector('.product-media-gallery')?.swiper;
  const slideIndex = (swiper, mediaId) => Array.from(swiper?.slides || []).findIndex((slide) => String(slide.dataset.mediaId) === String(mediaId));

  const slideToMedia = (gallery, mediaId, speed = 0) => {
    const swiper = mainSwiper(gallery);
    if (!swiper) return false;
    const index = slideIndex(swiper, mediaId);
    if (index < 0) return false;
    gallery.dataset.gemmariiLastAllowedMediaId = String(mediaId);
    swiper.gemmariiRedirecting = true;
    swiper.slideTo(index, speed);
    swiper.gemmariiRedirecting = false;
    return true;
  };

  const moveWithinVariant = (gallery, direction, speed = 300) => {
    const allowed = allowedMediaIds(gallery);
    const swiper = mainSwiper(gallery);
    if (!allowed.length || !swiper) return false;
    const activeMediaId = String(swiper.slides[swiper.activeIndex]?.dataset.mediaId || '');
    const currentMediaId = allowed.includes(activeMediaId) ? activeMediaId : gallery.dataset.gemmariiLastAllowedMediaId;
    const currentIndex = Math.max(0, allowed.indexOf(currentMediaId));
    const nextIndex = (currentIndex + direction + allowed.length) % allowed.length;
    return slideToMedia(gallery, allowed[nextIndex], speed);
  };

  const syncPaginationAndLightbox = (gallery) => {
    const allowed = allowedMediaIds(gallery);
    if (!allowed.length) return;
    const swiper = mainSwiper(gallery);
    const slides = swiper ? Array.from(swiper.slides) : Array.from(gallery.querySelectorAll('.product-media-gallery .media-child'));

    gallery.querySelectorAll('.swiper-pagination-main .swiper-pagination-bullet').forEach((bullet, index) => {
      const mediaId = String(slides[index]?.dataset.mediaId || '');
      const visible = allowed.includes(mediaId);
      bullet.hidden = !visible;
      bullet.setAttribute('aria-hidden', visible ? 'false' : 'true');
      bullet.tabIndex = visible ? 0 : -1;
    });

    slides.forEach((slide) => {
      const link = slide.querySelector('a[href]');
      if (!link) return;
      const visible = allowed.includes(String(slide.dataset.mediaId));
      link.toggleAttribute('data-gemmarii-lightbox-hidden', !visible);
      link.toggleAttribute('aria-hidden', !visible);
      if (visible) link.removeAttribute('tabindex');
      else link.setAttribute('tabindex', '-1');
    });

    const singleMedia = allowed.length <= 1;
    gallery.dataset.gemmariiSingleMedia = String(singleMedia);
    gallery.querySelectorAll('.nav-collection-list').forEach((controls) => {
      if (controls.closest('.product-thumbnails')) return;
      controls.hidden = singleMedia;
      controls.setAttribute('aria-hidden', String(singleMedia));
    });
  };

  const installVariantNavigation = (gallery) => {
    const swiper = mainSwiper(gallery);
    if (!swiper || swiper.gemmariiVariantNavigationReady) return Boolean(swiper);
    swiper.gemmariiVariantNavigationReady = true;
    swiper.allowTouchMove = false;
    if (swiper.params) swiper.params.allowTouchMove = false;
    swiper.on('slideChange', () => {
      if (swiper.gemmariiRedirecting) return;
      const allowed = allowedMediaIds(gallery);
      if (!allowed.length) return;
      const activeMediaId = String(swiper.slides[swiper.activeIndex]?.dataset.mediaId || '');
      if (allowed.includes(activeMediaId)) {
        gallery.dataset.gemmariiLastAllowedMediaId = activeMediaId;
        syncPaginationAndLightbox(gallery);
        return;
      }
      moveWithinVariant(gallery, swiper.swipeDirection === 'prev' ? -1 : 1, 0);
    });
    return true;
  };

  const retry = (fn, attempts = 0) => {
    if (fn() || attempts >= 12) return;
    requestAnimationFrame(() => retry(fn, attempts + 1));
  };

  const applyMediaVisibility = (gallery, mediaIds, preferredMediaId) => {
    const thumbnails = Array.from(gallery.querySelectorAll('.product-thumbnails .thumbnail-slide'));
    const availableIds = new Set(mediaIds.map(String));

    thumbnails.forEach((thumbnail) => {
      if (thumbnail.dataset.mediaShared === 'true') {
        availableIds.add(String(thumbnail.dataset.mediaId || ''));
      }
    });

    thumbnails.forEach((thumbnail) => {
      thumbnail.hidden = !availableIds.has(String(thumbnail.dataset.mediaId || ''));
    });

    const allowed = thumbnails
      .filter((thumbnail) => !thumbnail.hidden)
      .map((thumbnail) => String(thumbnail.dataset.mediaId || ''))
      .filter(Boolean);
    if (!allowed.length) return;

    const preferredPhotos = (gallery.dataset.gemmariiPreferredMediaIds || '').split(',').filter(Boolean);
    const productFirst = isTaurus(gallery)
      ? allowed.find(id => taurusProducts.includes(id))
      : allowed.find(id => preferredPhotos.includes(id));
    const preferred = productFirst || (allowed.includes(String(preferredMediaId || ''))
      ? String(preferredMediaId)
      : allowed[0]);
    gallery.dataset.gemmariiThumbnailsFiltered = 'true';
    gallery.dataset.gemmariiAllowedMediaIds = allowed.join(',');
    gallery.dataset.gemmariiLastAllowedMediaId = preferred;

    retry(() => installVariantNavigation(gallery));
    retry(() => slideToMedia(gallery, preferred, 0));
    syncPaginationAndLightbox(gallery);
    requestAnimationFrame(() => syncPaginationAndLightbox(gallery));

    const thumbnailSwiper = gallery.querySelector('.product-thumbnails')?.swiper;
    if (thumbnailSwiper) {
      thumbnailSwiper.update();
      thumbnailSwiper.setTranslate(0);
    }
  };

  const applyVariantMedia = (gallery, mediaId) => {
    const thumbnails = Array.from(gallery.querySelectorAll('.product-thumbnails .thumbnail-slide'));
    const selected = thumbnails.find((thumbnail) => String(thumbnail.dataset.mediaId) === String(mediaId));
    if (!selected) return;
    applyMediaVisibility(gallery, mediaIdsForSelection(gallery, mediaId, thumbnails), mediaId);
  };

  const applyOptionMedia = (selector, clickedOption) => {
    const product = selector.closest('.mainProduct') || selector.closest('.shopify-section');
    const gallery = product?.querySelector('wdt-main-media[data-variant-media-filter]');
    if (!gallery) return;

    const thumbnails = Array.from(gallery.querySelectorAll('.product-thumbnails .thumbnail-slide'));
    const mediaIds = mediaIdsForOptions(gallery, selector, thumbnails, clickedOption);
    if (mediaIds?.length) applyMediaVisibility(gallery, mediaIds, mediaIds[0]);
  };

  document.addEventListener('click', (event) => {
    const option = event.target.closest?.('variant-selector .variant-option-item');
    if (!option) return;
    setTimeout(() => applyOptionMedia(option.closest('variant-selector'), option), 0);
  }, true);

  document.addEventListener('change', (event) => {
    const selector = event.target.closest?.('variant-selector');
    if (selector && event.target.matches('select')) applyOptionMedia(selector);
  });

  document.addEventListener('gemmarii:variant-media-selected', (event) => {
    const gallery = event.target;
    if (!gallery?.matches?.('wdt-main-media[data-variant-media-filter]')) return;
    applyVariantMedia(gallery, String(event.detail?.mediaId || ''));
  });

  document.addEventListener('click', (event) => {
    const thumbnail = event.target.closest?.('.thumbnail-slide');
    const gallery = thumbnail?.closest?.('wdt-main-media[data-gemmarii-thumbnails-filtered="true"]');
    if (gallery && !thumbnail.hidden && slideToMedia(gallery, thumbnail.dataset.mediaId)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    const control = event.target.closest?.('.product-media-gallery .swiper-button-next, .product-media-gallery .swiper-button-prev');
    const controlGallery = control?.closest?.('wdt-main-media[data-gemmarii-thumbnails-filtered="true"]');
    if (!controlGallery || control.closest('.product-thumbnails')) return;
    if (!moveWithinVariant(controlGallery, control.classList.contains('swiper-button-prev') ? -1 : 1)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  document.addEventListener('touchstart', (event) => {
    const gallery = event.target.closest?.('wdt-main-media[data-gemmarii-thumbnails-filtered="true"]');
    const touch = event.touches?.[0];
    if (!gallery || !touch || !event.target.closest('.product-media-gallery')) return;
    touchStarts.set(gallery, { x: touch.clientX, y: touch.clientY });
  }, { capture: true, passive: true });

  document.addEventListener('touchend', (event) => {
    const gallery = event.target.closest?.('wdt-main-media[data-gemmarii-thumbnails-filtered="true"]');
    const touch = event.changedTouches?.[0];
    const start = gallery ? touchStarts.get(gallery) : null;
    if (!gallery || !touch || !start || !event.target.closest('.product-media-gallery')) return;
    touchStarts.delete(gallery);
    const deltaX = touch.clientX - start.x;
    const deltaY = touch.clientY - start.y;
    if (Math.abs(deltaX) < 35 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
    if (!moveWithinVariant(gallery, deltaX < 0 ? 1 : -1)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, { capture: true, passive: false });

  document.addEventListener('keydown', (event) => {
    if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    const gallery = event.target.closest?.('wdt-main-media[data-gemmarii-thumbnails-filtered="true"]');
    if (!gallery || !moveWithinVariant(gallery, event.key === 'ArrowLeft' ? -1 : 1)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  const initGallery = (gallery) => {
    orderTaurusMedia(gallery);
    const initialMediaId = String(gallery.dataset.selectedVariantId || '');
    if (initialMediaId) applyVariantMedia(gallery, initialMediaId);
  };

  const init = (root = document) => {
    root.querySelectorAll?.('wdt-main-media[data-variant-media-filter]').forEach(initGallery);
  };

  const initQuickViewLightbox = (root = document) => {
    const quickView = root.matches?.('#quickViewContent')
      ? root
      : root.querySelector?.('#quickViewContent');
    if (!quickView || !window.PhotoSwipeLightbox || !window.PhotoSwipe) return;

    quickView.querySelectorAll('.product__media-list').forEach((lightboxGallery) => {
      if (lightboxGallery.gemmariiPhotoSwipeLightbox) return;

      const lightbox = new window.PhotoSwipeLightbox({
        gallery: lightboxGallery,
        children: 'a:not([data-gemmarii-lightbox-hidden])',
        pswpModule: window.PhotoSwipe
      });
      lightbox.init();
      lightboxGallery.gemmariiPhotoSwipeLightbox = lightbox;
    });
  };

  const initAll = (root = document) => {
    init(root);
    initQuickViewLightbox(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target || document);
  });
})();


